import React from "react";
import "./hero.css";

const OfferBanner = () => {
  return (
    <div
      className="text-white py-5"
      style={{
        backgroundColor: "black",
        fontFamily: "'Barlow Condensed', sans-serif",
        borderRadius: "10px",
        paddingInline: "20px",
      }}
    >
      <div className="container text-center px-3 px-md-5">
     <h2
  className="mb-3"
  style={{
    fontSize: "2.5rem",
  }}
  data-sal="fade"
  data-sal-duration="800"
  data-sal-delay="100"
>
  <div className="d-flex flex-column flex-md-row justify-content-center text-center">
    <span
      className="d-block d-md-inline text-white me-md-2"
      data-sal="slide-right"
      data-sal-duration="700"
    >
      LET'S CREATE SOMETHING
    </span>
    <span
      className="d-block d-md-inline text-white"
      data-sal="slide-left"
      data-sal-duration="700"
      data-sal-delay="100"
    >
      GREAT TOGETHER
    </span>
  </div>
</h2>

<p className="mb-2 fs-5" data-sal="fade" data-sal-duration="600" data-sal-delay="200">
  You don’t need to spend a lot to create a beautiful bathroom.
</p>
<p className="mb-4 fs-6" data-sal="fade" data-sal-duration="600" data-sal-delay="300">
  Your bathroom is where you start and end your day, so it should be
  more than just functional—it should be a relaxing retreat you enjoy.
</p>

<button
  className="btn text-light custom-btn1 text-uppercase fw-semibold rounded-pill px-4 px-md-5 py-2 py-md-3 fs-6 fs-md-5"
  style={{ backgroundColor: "#d8b163" }}
  data-sal="zoom-in"
  data-sal-duration="700"
  data-sal-delay="400"
>
  Get Started Today!
</button>

      </div>
    </div>
  );
};

export default OfferBanner;
